import React from 'react'

export default function Footer() {
    return (
        <>

            <div id="footer" class="footer">

                <div class="container">
                    <div class="row gy-4">
                        <div class="col-lg-3 col-md-6 d-flex">
                            <i class="bi bi-geo-alt icon"></i>
                            <div>
                                <h4>Address</h4>
                                <p>
                                Bd de Parc, 77700 Coupvray, France<br />

                                Disney Parks, Experiences and Products; (The Walt Disney Company)<br />70123
                                </p>



                            </div>

                        </div>

                        <div class="col-lg-3 col-md-6 footer-links d-flex" id="footer1">
                            <i class="bi bi-telephone icon"></i>
                            <div>
                                <h4>Reservations</h4>
                                <p>
                                    <strong>Customer Care:</strong>+91 18001029100<br />
                                    <strong>Email:</strong> serviceparis@disneyland.com<br />
                                </p>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 footer-links d-flex" id="footer1">
                            <i class="bi bi-clock icon"></i>
                            <div>
                                <h4>Opening Hours</h4>
                                <p>
                                    <strong>Mon-Sat: 11AM - 11PM </strong><br />
                                    Sunday: Closed
                                </p>
                            </div>
                        </div>

                        <div class="col-lg-3 col-md-6 footer-links">
                            <h4>Follow Us</h4>
                            <div class="social-links d-flex" id="footericon">
                                <a href="https://twitter.com/DisneyParis_EN/status/1434810695665819650" class="twitter"><i class="fa-brands fa-twitter"></i></a>
                                <a href="https://www.facebook.com/DisneylandParis/" class="facebook"><i class="fa-brands fa-facebook"></i></a>
                                <a href="https://www.instagram.com/disneylandparis/" class="instagram"><i class="fa-brands fa-instagram"></i></a>
                                <a href="https://www.linkedin.com/company/disneyland-paris" class="linkedin"><i class="fa-brands fa-linkedin-in"></i></a>
                                <a href="https://www.youtube.com/user/disneylandparis" class="YouTube"><i class="fa-brands fa-youtube"></i></a>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="container">
                    <div class="copyright">
                        Designed By <strong> <span>Sanskar Kulkarni.</span> </strong> 
                    </div>
                    <div class="credits">
                      <strong><span><a href="Disney land">Disney land , Paris</a></span></strong>
                    </div>
                </div>

            </div>

        </>
    )
}
